import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiService } from 'src/app/services/api.service';
import { ServerTypes } from 'src/app/models/servers';
import { Observable } from 'rxjs';
import { requests } from 'src/app/models/requests';
import { ChangePasswordData } from 'src/app/interfaces/change-password-data';
import { UntypedFormGroup } from '@angular/forms';
import { AppStorageEnum } from 'src/app/models/storage.enum';

@Injectable()
export class ChangePasswordService {
  constructor(private http: HttpClient, private apiService: ApiService) {}

  private get url(): string {
    return this.apiService.getCurentServer(ServerTypes.auth);
  }

  public changePassword(form: UntypedFormGroup): Observable<any> {
    const passData: ChangePasswordData = {
      username: form.get('username')
        ? form.get('username').value
        : sessionStorage.getItem(AppStorageEnum.boUser),
      oldPassword: form.get('password').value,
      newPassword: form.get('updatedPassword').value,
    };
    return this.http.put(this.url + requests.changePassword, passData);
  }
}
